import React from 'react';
import { 
  Container, Wrapper, Row, Column, Links, Title, List, FooterBottom, 
  LogoContainer, SubscribeColumn, IconWrapper 
} from './styles/StyledFooter';

export default function Footer({ children, ...restProps }) {
  return <Container {...restProps}>{children}</Container>;
}

Footer.Wrapper = function FooterWrapper({children, ...restProps}) {
  return <Wrapper {...restProps}>{children}</Wrapper>;
}

Footer.Row = function FooterRow({ children, ...restProps }) {
  return <Row {...restProps}>{children}</Row>;
};

Footer.Column = function FooterColumn({ children, ...restProps }) {
  return <Column {...restProps}>{children}</Column>;
};

Footer.Links = function FooterLink({ children, ...restProps }) {
  return <Links {...restProps}>{children}</Links>;
};

Footer.Link2 = function FooterLink2({ children, ...restProps }) {
  return <Links as="a" {...restProps}>{children}</Links>;
};

Footer.Title = function FooterTitle({ children, ...restProps }) {
  return <Title {...restProps}>{children}</Title>;
};

Footer.List = function FooterList({ children, ...restProps }) {
  return <List {...restProps}>{children}</List>;
};

Footer.FooterBottom = function FooterFooterBottom({ children, ...restProps }) {
  return <FooterBottom {...restProps}>{children}</FooterBottom>;
};

Footer.LogoContainer = function FooterLogoContainer({ children, ...restProps }) {
  return <LogoContainer {...restProps}>{children}</LogoContainer>;
};

Footer.SubscribeColumn = function FooterSubscribeColumn({ children, ...restProps }) {
  return <SubscribeColumn {...restProps}>{children}</SubscribeColumn>;
};

Footer.IconWrapper = function FooterIconWrapper({ children, ...restProps }) {
  return <IconWrapper {...restProps}>{children}</IconWrapper>;
};